import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { environment } from 'src/environments/environment'
import { clientFilter, ClientList } from '../../models/client.model'
import { Router } from '@angular/router'

@Component({
	selector: 'app-client-table',
	templateUrl: './client-table.component.html',
	styleUrls: ['./client-table.component.scss'],
})
export class ClientTableComponent implements OnInit {
	@Input() clients: ClientList[] = []

	@Input() clientFilter: clientFilter = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		countryId: null,
	}
	@Input() totalCount = 0
	@Output() actionChanged: EventEmitter<any> = new EventEmitter()
	subscription = new Subscription()
	imagePath = environment.attachmentPath
	constructor(private router: Router) {}

	ngOnInit(): void {}
	// viewClientDetails(id: any) {
	// 	this.router.navigateByUrl('/layout/client/client-profile/' + id)
	// }
}
